exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"radio\"][data-v-4c1d52f0] {\n  display: none;\n}\n.radio-check[data-v-4c1d52f0] {\n  cursor: pointer;\n}\n", ""]);

// exports
